module.exports = __webpack_public_path__ + "static/media/down-chevron.09c7d29a.svg";